import {
    ImportantDateState,
    FetchState,
    ImportantDateRequest
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import { defineStore } from "pinia";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";

export const initialState: ImportantDateState = {
    fetchState: FetchState.Uninitialized,
    importantDates: []
};
export const useImportantDateStore = defineStore("importantDate", {
    state: (): ImportantDateState => (_.cloneDeep(initialState)),
    getters: {
        importantDatesList: state => state.importantDates,
        isDatesLoaded: state => state.fetchState === FetchState.Loaded
    },
    actions: {
        setImportantDates (dates) {
            this.importantDates = dates;
            this.fetchState = FetchState.Loaded;
        },
        setStatusToLoading () {
            this.fetchState = FetchState.Loading;
        },
        resetStatus () {
            this.fetchState = FetchState.Uninitialized;
        },
        getImportantDateList (request: ImportantDateRequest) {
            if (this.fetchState === FetchState.Loaded) {
                return;
            }
            this.setStatusToLoading();
            const notifierStore = useNotifierStore();
            UserService.getImportantDates(request).then(response => {
                this.setImportantDates(response.data);
            }).catch(err => {
                this.resetStatus();
                notifierStore.setDanger("Error loading important dates");
            });
        }
    }
});

